"use client";

import { useSettingRecordBrowserIDTracking } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingRecordBrowserIDTracking";
import { BROWSER_ID } from "@faire/web/common/consts/BROWSER_ID";
import {
  getCookies,
  removeCookie,
  setCookies,
} from "@faire/web/common/cookies";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

export const BROWSER_ID_EXPIRES_IN_DAYS = 180;

export const BrowserIdSetUp = () => {
  const shouldRecordBrowserId = useSettingRecordBrowserIDTracking();

  useEffect(() => {
    const currentBrowserId: string | undefined = getCookies(BROWSER_ID);

    const oneTrustActiveGroups = getGlobalProperty("OnetrustActiveGroups");
    const hasPerformanceTracking =
      String(oneTrustActiveGroups).includes("C0002");
    const isBrowserIDTrackingEnabled =
      shouldRecordBrowserId && hasPerformanceTracking;
    if (isBrowserIDTrackingEnabled && !currentBrowserId) {
      const newBrowserId = uuidv4();
      setCookies(BROWSER_ID, newBrowserId, BROWSER_ID_EXPIRES_IN_DAYS);
    } else if (!isBrowserIDTrackingEnabled && currentBrowserId) {
      removeCookie(BROWSER_ID);
    }
  }, [shouldRecordBrowserId]);

  return null;
};
